import { render } from "./OurVisionComp.vue?vue&type=template&id=3c928941&scoped=true"
const script = {}

import "./OurVisionComp.vue?vue&type=style&index=0&id=3c928941&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c928941"]])

export default __exports__